import {
    AfterViewInit,
    Component,
    ElementRef, EventEmitter,
    HostListener,
    Input,
    OnChanges, Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {TouchedType} from "../../../model/slilder";
import {SliderItemComponent} from "../slider-item/slider-item.component";
import {DeviceDetectorService} from "ngx-device-detector";
import {FullScreenSliderComponent} from "../full-screen-slider/full-screen-slider.component";
import {Article} from "../../../model/article";

@Component({
    selector: 'app-slider-horizontal',
    imports: [
        NgForOf,
        SliderItemComponent,
        NgIf,
        FullScreenSliderComponent
    ],
    templateUrl: './slider-horizontal.component.html',
    styleUrl: './slider-horizontal.component.scss',
    standalone: true,
})
export class SliderHorizontalComponent implements AfterViewInit {
    @ViewChild('container') container!: ElementRef;
    @ViewChild('movableElement') movableElement!: ElementRef;
    @Input() grid: number = 1;
    @Input() step: number = 1;
    @Input() elements: any[] = [];
    @Input() test: boolean = false;
    @Input() backgroundContain: boolean = true;
    @Output() emitActive: EventEmitter<any> = new EventEmitter<any>();

    widthContainer: number = 0;
    heightContainer: number = 0;
    widthEl: number = 0;
    limit: number = 200;
    formattedElements: Article[] = [];
    activeEl: number = 0;
    private isDragging = false;
    private startX = 0;
    private scrollLeft = 0;
    private startLeft = 0;
    isMobile: boolean = false;

    scrolling: boolean = false;

    activeFullScreen: boolean = false;
    activePhotoIndex: number = 0;
    activePhoto: string = '';
    activePhotos: string[] = [];



    constructor(private deviceService: DeviceDetectorService) {}

    getSize() {
        this.widthContainer = this.container.nativeElement.offsetWidth;
        this.heightContainer = this.container.nativeElement.offsetHeight;
        this.widthEl = this.widthContainer / this.grid;
        if (this.widthContainer < 756) {
            this.limit = 100;
        } else {
            this.limit = 200;
        }

        this.getFormattedElements();
    }

    setActiveEl(el: number) {
        this.activeEl = el;
        this.switchToElement(el);
    }
    getFormattedElements() {
        this.formattedElements = this.elements;
        // const length = this.elements.length;
        // const active = this.activeEl; // можно добавить настройку
        // const grid = this.grid;
        // const step = this.step; // можно добавить настройку
        // for (let i = 0; i < step * 2 + grid; i++) {
        //     if (i < step) {
        //         const idx = active - step + i;
        //         if (idx < 0) {
        //             this.formattedElements[i] = this.elements[length + idx];
        //         } else {
        //             this.formattedElements[i] = this.elements[idx];
        //         }
        //     } else if (i < step + grid ) {
        //         const idx = active + i - step;
        //         if (idx > length - 1) {
        //             this.formattedElements[i] = this.elements[idx - length];
        //         } else {
        //             this.formattedElements[i] = this.elements[idx];
        //         }
        //     } else if (i < step * 2 + grid) {
        //         const idx = active + i - step - grid + grid ;
        //         if (idx > length - 1) {
        //             this.formattedElements[i] = this.elements[idx - length];
        //
        //         } else {
        //             this.formattedElements[i] = this.elements[idx];
        //         }
        //     }
        // }
        // setTimeout(() => {
        //     this.movableElement.nativeElement.scrollTo({
        //     left: this.widthEl * this.step,
        //   });
        // }, 0);
    }
    onWheel(event: WheelEvent) {
        if (this.scrolling && event.deltaY !== 0 && !this.isMobile) {
            return;
        } else {
            event.preventDefault();
        }
    }

    onScroll(event: Event) {
        if (this.scrolling && !this.isMobile) {
            return;
        } else {
            event.preventDefault();
        }
    }

    changeScrolling(boll: boolean) {
        this.scrolling = boll;
    }

    setSliderStyles() {
        const w = 'min-width: ' + this.widthEl + 'px;'
        return w;
    }


    handleDoubleClick(event: MouseEvent) {
        this.openFullScreen();
    }

    clickMobile() {
        if (this.isMobile) {
            this.openFullScreen();
        }
    }

    scrollToElementSwipe(type: string) {
        if (type == 'left') {
            const newId = this.activeEl - 1;
            if (newId > -1) {
                this.activeEl -= 1;
                this.emitActive.emit(this.elements[this.activeEl]);
                this.scrollToElement(-this.widthEl);
            }
        } else {
            const newId = this.activeEl + 1;
            if (newId < this.elements.length - 1) {
                this.activeEl += 1;
                this.emitActive.emit(this.elements[this.activeEl]);
                this.scrollToElement(this.widthEl);
            }
        }
    }


    scrollToElement(value: number) {
        this.movableElement.nativeElement.scrollBy({
            left: value,
            behavior: 'smooth'
        });
    }

    switchToElement(index: number) {
        this.movableElement.nativeElement.scrollTo({
            left: index * this.widthEl,
        });
    }

    startDrag(event: MouseEvent | TouchEvent) {
        if( this.isMobile ) {
            if (event instanceof TouchEvent ) {
                this.swipe(event, 'start');
            }
        } else {
            this.isDragging = true;
            this.startLeft = this.movableElement.nativeElement.scrollLeft;
            this.startX = event instanceof MouseEvent ? event.pageX : event.touches[0].pageX;
            this.scrollLeft = this.movableElement.nativeElement.scrollLeft;
            // Изменяем курсор
            this.movableElement.nativeElement.style.cursor = 'grabbing';
        }

    }

    endDrag(event: MouseEvent | TouchEvent) {
        if( this.isMobile ) {
            if (event instanceof TouchEvent ) {
                this.swipe(event, 'end');
            }
        } else {
            if (this.isDragging) {
                this.isDragging = false;
                this.movableElement.nativeElement.style.cursor = 'grab';
                this.scrollToNearest();
            }
        }
    }

    onTouchMove(event: TouchEvent) {
        if( this.isMobile ) {
            console.log('on moving');
        } else {
            if (!this.isDragging) return;
            const x = event.touches[0].pageX;
            const walk = (x - this.startX) * 2; // Увеличиваем скорость прокрутки
            if (Math.abs(walk) < this.limit * 1.3) {
                this.movableElement.nativeElement.scrollLeft = this.scrollLeft - walk;
            }
            if (this.scrolling) {
                event.stopPropagation(); // Предотвращаем прокрутку страницы
            } else {
                event.preventDefault(); // Предотвращаем прокрутку страницы
            }
        }
    }

    @HostListener('mousemove', ['$event'])
    onMouseMove(event: MouseEvent) {
        if (this.isMobile) {
            console.log('on moving');
        } else {
            if (!this.isDragging) return;
            const x = event.pageX;
            const walk = (x - this.startX) * 2; // Увеличиваем скорость прокрутки
            if (Math.abs(walk) < this.limit * 1.3) {
                this.movableElement.nativeElement.scrollLeft = this.scrollLeft - walk;
                event.preventDefault(); // Предотвращаем прокрутку страницы
            }
        }

    }

    scrollToNearest() {
        const pos = this.movableElement.nativeElement.scrollLeft;
        const start = this.startLeft;
        const del = pos - start;
        const x = Math.ceil(pos / this.widthEl);
        const leftEl = x == 0 ? 0 : x - 1;
        if (Math.abs(del) >= this.limit) {
            if (del >= 0) {
                const left = this.widthEl * (leftEl + 1) - pos;
                this.scrollToElement(left);
                this.activeEl += 1;
                this.emitActive.emit(this.elements[this.activeEl]);
            } else {
                const left = this.widthEl * leftEl - pos;
                this.scrollToElement(left);
                this.activeEl -= 1;
                this.emitActive.emit(this.elements[this.activeEl]);
            }
        } else {
            this.scrollToElement(-del);
        }
    }

    private swipeCoord?: [number, number];
    private swipeTime?: number;
    swipe(event: TouchEvent, when: string): void {
        const coord: [number, number] = [event.changedTouches[0].clientX, event.changedTouches[0].clientY];
        const time = new Date().getTime();
        if (when === 'start') {
            this.swipeCoord = coord;
            this.swipeTime = time;
            console.log('start');
        } else if (when === 'end') {
            // @ts-ignore
            const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
            // @ts-ignore
            const duration = time - this.swipeTime;
            if (duration < 600 //
                && Math.abs(direction[0]) > 30 // Long enough
                && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
                const swipe = direction[0] < 0 ? 'next' : 'previous';
                if (direction[0] < 0) {
                    this.scrollToElement(this.widthEl);
                    console.log('right');
                } else {
                    this.scrollToElement(-this.widthEl);
                    console.log('left');
                }
            } else {
                console.log('no swipe');
            }
        }
    }

    openFullScreen() {
        this.activePhotoIndex = 0;
        const ar = this.formattedElements[this.activeEl];
        if (ar.imgs) {
            if (ar.imgs.length > 0) {
                this.activePhotos = ar.imgs;
                this.activePhoto = this.activePhotos[0];
                this.activeFullScreen = true;
            }
        } else if (ar.img) {
            this.activePhotos = [];
            this.activePhotos.push(ar.img);
            this.activePhoto = this.activePhotos[0];
            this.activeFullScreen = true;
        }
    }

    nextPhoto() {
        this.activePhotoIndex = this.activePhotoIndex - 1;
        if (this.activePhotoIndex < 0) {
            this.activePhotoIndex = this.activePhotos.length - 1;
        }
        this.activePhoto = this.activePhotos[this.activePhotoIndex];

    }

    prevPhoto() {
        this.activePhotoIndex = this.activePhotoIndex + 1;
        if (this.activePhotoIndex > this.activePhotos.length - 1) {
            this.activePhotoIndex = 0;
        }
        this.activePhoto = this.activePhotos[this.activePhotoIndex];
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.getSize();
            this.isMobile = this.deviceService.isMobile();
        });
    }


    protected readonly TouchedType = TouchedType;
    protected readonly event = event;
}
